/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface KokpitPackageNameListDto
 */
export interface KokpitPackageNameListDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitPackageNameListDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitPackageNameListDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KokpitPackageNameListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitPackageNameListDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the KokpitPackageNameListDto interface.
 */
export function instanceOfKokpitPackageNameListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitPackageNameListDtoFromJSON(json: any): KokpitPackageNameListDto {
    return KokpitPackageNameListDtoFromJSONTyped(json, false);
}

export function KokpitPackageNameListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitPackageNameListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function KokpitPackageNameListDtoToJSON(value?: KokpitPackageNameListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'name': value.name,
        'description': value.description,
    };
}

